import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class MaintainerAuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router:  Router) {

  }
  canActivate() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized() && (auth.isAdmin() || auth.isMaintainer())){
        return true;
    } else {
        this.router.navigate([auth.isAuthorized() && auth.isMaintainer() ? 'admin/devices' : (auth.isAdmin() ? 'admin' : 'login')]);
        // this.router.navigate([auth.isAuthorized() && auth.isAdmin() ? 'admin' : 'login']);
        return false;
    }
  }

  canActivateChild() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized() && (auth.isAdmin() || auth.isMaintainer())){
        return true;
    } else {
        this.router.navigate([auth.isAuthorized() && auth.isMaintainer() ? 'admin/devices' : (auth.isAdmin() ? 'admin' : 'login')]);
        return false;
    }
  }

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/maintainer-guard.service.ts